document.addEventListener('recommendations:loaded', function(event) {
    var slider = event.target.querySelector('.js-complementary-slider');
    if (slider && typeof Flickity !== 'undefined') {
    var flkty = new Flickity(slider, {
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        pageDots: true,
        prevNextButtons: true,
        freeScroll: false,
        adaptiveHeight: true,
        imagesLoaded: true
    });
    var counter = event.target.querySelector('complementary-carousel-counter');
    var currentEl = counter && counter.querySelector('[data-current]');

    if (currentEl) {
    flkty.on('change', function(index) {
        currentEl.textContent = index + 1;
    });
    }
}
});
